import { render } from "./StepRealName.vue?vue&type=template&id=cd0e088c"
import script from "./StepRealName.vue?vue&type=script&lang=js"
export * from "./StepRealName.vue?vue&type=script&lang=js"

import "./StepRealName.vue?vue&type=style&index=0&id=cd0e088c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__